export default {"src":"https://fishbrain.com/_next/static/media/salmon.6faaa80e.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};